import React, {Fragment, useEffect, useState} from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import ScheduleIcon from '@material-ui/icons/Schedule';
import WorkIcon from '@material-ui/icons/Work';
import PersonIcon from '@material-ui/icons/Person';
import SearchIcon from '@material-ui/icons/Search';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import {List, GridList, Popover, Popup, PlusButton, Folder_system, Card} from '../../../../components';
import {connect} from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme=>({
  top_bar:{
    width:'100vw',
    marginLeft:'-10px',
    ['@media (min-width:600px)']:{
      width:'calc(100vw - 60px)',
      marginLeft:'-20px'
    },
  }
}));



function Delete_popup(props){


  function onDelete(id){
    props.deleteSequence(id);
    props.handleClose();
  }

  return(
    <Popup always_open title={'Delete sequence'} accept_button='Delete' handleClose={props.handleClose} accept_button_click={()=>{onDelete(props.sequence.id);}} content={
      <div style={{width:'95vw', maxWidth:'600px', height:'200px', display:'flex', justifyContent:'center', alignItems:'center'}}>
        <div style={{width:'calc(100% - 40px)', marginLeft:'20px'}}><Typography style={{width:'100%', textAlign:'center'}}>{"Are you sure you want to permanently delete '"+props.sequence.name+"' sequence? This action can not be undone."}</Typography></div>
      </div>
    }/>
  )
}


function Clone_popup(props){

  function onClone(id){
    props.cloneSequence(id);
    props.handleClose();
  }

  return(
    <Popup always_open title={'Clone sequence'} accept_button='Clone' handleClose={props.handleClose} accept_button_click={()=>{onClone(props.sequence.id);}} content={
      <div style={{width:'95vw', maxWidth:'600px', height:'200px', display:'flex', justifyContent:'center', alignItems:'center'}}>
        <div style={{width:'calc(100% - 40px)', marginLeft:'20px'}}><Typography style={{width:'100%', textAlign:'center'}}>{"Are you sure you want to clone this sequence?"}</Typography></div>
      </div>
    }/>
  )
}


function SequencesSection(props){
  let classes=useStyles();
  const[search, setSearch]=useState('');
  const[delete_popup, setDeletePopup]=useState(undefined);
  const[clone_popup, setClonePopup]=useState(undefined);
  const[current_folder_id, setCurrentFolderId]=useState(undefined);

  useEffect(()=>{
    if(props.sequences_index!=true){props.getSequences();}
    if(props.templates_index!=true){props.getTemplates();}
  },[])
  let users_length=0; if(props.workspace!=undefined){for(let uk in props.workspace.all_user_workspaces){let u=props.workspace.all_user_workspaces[uk]; if(u.invisible!=true){if(u.superuser!=true && u.user_id!=null && u.user_id!=undefined){users_length+=1;}}}}
  if(props.workspace!=undefined && props.workspace.active_subscription!=undefined){users_length=props.workspace.active_subscription.quantity;}
  let w_limit=null; if(props.workspace!=null && props.workspace!=undefined && props.workspace.free_account!=true){w_limit=(props.workspace.active_subscription==null)?0:props.workspace.active_subscription.max_sequences; w_limit=w_limit*users_length;}
  let sequences=[]; let i=0; for(let key in props.sequences){i+=1; let name=props.sequences[key].name.toLowerCase(); let description=props.sequences[key].description.toLowerCase(); if(search=='' || name.includes(search.toLowerCase()) || description.includes(search.toLowerCase())){sequences.push({disabled:(w_limit!=null && i>w_limit), ...props.sequences[key]});}}
  return(
    <div style={{marginTop:'60px'}}>
      {((w_limit != null && w_limit > sequences.length) || (props.workspace != undefined && props.workspace.free_account == true)) ? <PlusButton current_folder_id={current_folder_id} folder_type="SEQUENCES" options={[{label:'Sequence', icon:<ScheduleIcon/>, action:()=>{props.history.push('/email/sequences/new')}}]}/>:null}
    <div className={classes.top_bar} style={{boxShadow:'1px 1px 4px #888888', position:'relative', paddingTop:'12px', paddingBottom:'2px', zIndex:'3'}}>
    <Grid container>
      <Grid item xs={12} sm={6} md={4}><div style={{width:'calc(100% - 60px)', marginLeft:'30px'}}><TextField type='name' InputProps={{startAdornment:<SearchIcon/>}} variant='outlined' size='small' label='Search' value={search} onChange={(e)=>{setSearch(e.target.value)}} style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'5px', marginBottom:'5px', backgroundColor:'#f7f9fc'}}/></div></Grid>
      {(w_limit==null)?null:<Grid item xs={12} sm={6} md={4}><div style={{width:'calc(100% - 60px)', marginLeft:'30px', marginTop:'5px', height:'25px', borderRadius:'5px', borderColor:'orange', borderStyle:'solid', borderWidth:'1px', backgroundColor:'white', position:'relative'}}><Typography style={{position:'relative'}}><div style={{borderRightWidth:'1px', borderRightStyle:'solid', borderRightColor:'grey', alignItems:'center', justifyContent:'center', height:'25px', position:'absolute', left:'0px', top:'0px', width:'50px', textAlign:'center', display:'flex', justifyContent:'center', alignItems:'center'}}><div>{sequences.length+'/'+w_limit}</div></div><div style={{marginLeft:'60px', width:'calc(100% - 60px)', height:'25px', display:'flex', justifyContent:'center', alignItems:'center'}}><a href='/payments/subscriptions'>Upgrade subscription?</a></div></Typography></div></Grid>}
    </Grid>
    </div>
    <div style={{width:'100%', height:'calc(100vh - 125px)'}}>
      <Folder_system folder_type="SEQUENCES" resources={sequences} updateResource={props.updateSequence} setCurrentFolderId={setCurrentFolderId} displayResources={(sequences) => {
      return(<GridList list_items={sequences} rowHeight={130} responsive_columns={{0:1, 900:2, 1350:3, 1800:4}} component={(x)=>{
        let options_list=[]
        if((props.workspace!=undefined && props.workspace.active_subscription!=undefined && props.workspace.active_subscription.max_sequences>sequences) || (props.workspace!=undefined && props.workspace.free_account==true)){options_list.push({id:2, icon:<FileCopyIcon color='primary'/>, main_text:'Clone'});}

          options_list.push({id:5, icon:<EditIcon color='primary'/>, main_text:'Edit'}); options_list.push({id:4, icon:<DeleteIcon color='error'/>, main_text:'Delete'});

        return(
          <Card id={x.id} key={x.id} index={x.id} text={
          <div style={{height:'100%', width:'100%', position:'relative', marginTop:'20px'}}>{
            <Paper style={{overflowX:'hidden', overflowY:'hidden', height:'110px', width:'calc(100% - 40px)', marginLeft:'20px', position:'relative'}}>
              {(x.disabled==true)?<div style={{position:'absolute', width:'100%', height:'100%', backgroundColor:'black', zIndex:1000, opacity:'0.4'}}/>:null}
              <div style={{boxShadow:'1px 1px 4px #888888', position:'relative', zIndex:'2', marginTop:'-10px', paddingTop:'8px'}}><Typography color='primary' style={{marginLeft:'30px', marginTop:'5px', marginBottom:'5px'}}>{(x.workspace_share==true)?<Tooltip title='Available to workspace'><WorkIcon style={{position:'absolute', left:'5px', top:'11px', width:'20px'}}/></Tooltip>:<Tooltip title='Personal sequence'><PersonIcon style={{position:'absolute', left:'5px', top:'11px', width:'20px'}}/></Tooltip>}{x.name}<Popover style={{position:'absolute', right:'0px'}} trigger={<MoreVertIcon color='primary' style={{position:'absolute', right:'0px', top:'0px', cursor:'pointer'}}/>} content={
                <div style={{width:'140px'}}>
                <List onClick={(item)=>{if(item.id==5){props.history.push('/email/sequences/'+x.id+'/edit');}else if(item.id==4){setDeletePopup(x);}else if(item.id==2){setClonePopup(x);}else{console.log(item);}}} list_data={options_list}/>
                </div>
              }/></Typography></div>
              <div style={{height:'calc(100% - 30px)', position:'relative', overflowY:'scroll', zIndex:'1', marginTop:'-3px'}}>
                {x.sequence_emails.map(function(se, index){
                  let types=['seconds', 'minutes', 'hours', 'days', 'weeks', 'months'];
                  let template=(props.templates==undefined || props.templates[se.html_template_id]==undefined)?'':props.templates[se.html_template_id].name;
                  console.log(template, se.html_template_id, props.templates);
                  return(<div><Typography variant='caption' style={{marginLeft:'15px', marginTop:'10px', paddingLeft:'20px', position:'relative'}}><Typography color='primary' variant='caption'  style={{position:'absolute', left:'0px'}}>{(index+1)+')'}</Typography>{'After '+se.wait+' '+types[se.type]+': send '}<span style={{textDecoration:'underline', cursor:'pointer', color:'rgb(0, 116, 225)'}} onClick={()=>{props.history.push('/emails/templates/'+se.html_template_id+'/show')}}>{template}</span></Typography></div>)
                })}
              </div>
            </Paper>
          }</div>}/>
        )}}
      />)}}/>
    </div>
    {(clone_popup!=undefined)?<Clone_popup {...props} sequence={clone_popup} handleClose={()=>{setClonePopup(undefined)}}/>:null}
    {(delete_popup!=undefined)?<Delete_popup {...props} sequence={delete_popup} handleClose={()=>{setDeletePopup(undefined)}}/>:null}
    </div>
  );
}

export default connect(ss,dd)(SequencesSection);


function ss(state){
    return{
      workspace:(state.workspaces.data==undefined)?undefined:state.workspaces.data[state.workspaces.current_workspace_id],
      sequences:state.templates.sequences,
      templates:state.templates.templates,
      refresh:state.templates.refresh,
      sequences_index:state.templates.sequences_index,
      templates_index:state.templates.templates_index
    }
}

function dd(dispatch){
    return{
      updateSequence: (id, data) => { dispatch({ type: 'REQUEST_UPDATE_EMAIL_SEQUENCE', id: id, payload: data }) },
      getTemplates:()=>{dispatch({type:'REQUEST_INDEX_HTML_TEMPLATES'});},
      getSequences:()=>{dispatch({type:'REQUEST_INDEX_EMAIL_SEQUENCES'});},
      deleteSequence:(id)=>{dispatch({type:'REQUEST_DELETE_EMAIL_SEQUENCE', id:id});},
      cloneSequence:(id)=>{dispatch({type:'REQUEST_CLONE_EMAIL_SEQUENCE', id:id});},
    }
}
